<template>
  <div>
    <a class="btn green" @click="showModal = !showModal" v-if="!locked">
      {{ field.button }}
    </a>
    <button :id="field.name+'btn-remove'"
            v-if="!locked && imageDataUrl"
            @click.prevent="removeUploadedImage(field.name)"
            class="btn default">Remove image
    </button>
    <vue-image-crop-upload :field="field.name"
                           v-model="showModal"
                           @crop-success="cropSuccess"
                           @crop-upload-success="cropUploadSuccess"
                           @crop-upload-fail="cropUploadFail"
                           :noRotate="false"
                           :width="300"
                           :height="300"
                           lang-type="en"
                           :lang-ext="languageExtend"
                           img-format="png"></vue-image-crop-upload>
    <img :src="showInitial ? initialUrl : imageDataUrl"
         class="imagecrop-preview"
         :id="field.name">
  </div>
</template>

<script>
import { ref, computed } from "vue";

import VueImageCropUpload from 'vue-image-crop-upload';

import {BUCKET_URL} from '@/http-common';

export default {
  props: {
    value: {
      type: String,
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    folder: {
      type: String,
      required: false,
    }
  },

  components: {VueImageCropUpload},

  emits: ['input'],

  setup(props, { emit }) {
    const imageDataUrl = ref()
    const showModal = ref(false)

    const cropSuccess = (imgDataUrl) => {
      imageDataUrl.value = imgDataUrl;
      emit('input', imgDataUrl);
    }

    const removeUploadedImage = () => {
      imageDataUrl.value = null
    }

    const languageExtend = {
      hint: 'Click or drag the file here to upload',
      loading: 'Uploading…',
      noSupported: 'Browser is not supported, please use IE10+ or other browsers',
      success: 'Upload success',
      fail: 'Upload failed',
      preview: 'Preview',
      btn: {
        off: 'Cancel',
        close: 'Close',
        back: 'Back',
        save: 'Save'
      },
      error: {
        onlyImg: 'Image only',
        outOfSize: 'Image exceeds size limit: ',
        lowestPx: 'Image size must be a minimum of (pixels): '
      }
    }

    const showInitial = computed(() => {
      // if value starts with `data:` it means that it is freshly uploaded image
      return !props.value.startsWith('data:');
    })

    const initialUrl = computed(() => {
      // if it's already uploaded image we need to add bucket and folder to the url
      if (props.value) {
        return `${BUCKET_URL}${props.folder}/${props.value}`;
      }
    })

    return {
      cropSuccess,
      removeUploadedImage,
      languageExtend,
      imageDataUrl,
      showInitial,
      initialUrl,
      showModal,
      cropUploadSuccess: () => {console.log(arguments)},
      cropUploadFail: () => {console.log(arguments)},
    }
  }
}
</script>

<style lang="scss">

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item:last-child img {
  border-radius: 100% !important;
}

.imagecrop-preview {
  max-height: 200px;
  padding-left: 20px;
}

.vue-image-crop-upload .vicp-wrap .vicp-operate a {
  color: #d09f23 !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-fill-lower {
  background-color: rgba(208, 159, 35, 0.3) !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-fill-upper {
  background-color: rgba(208, 159, 35, 0.15) !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-webkit-slider-runnable-track {
  background-color: rgba(208, 159, 35, 0.5) !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-moz-range-track {
  background-color: rgba(208, 159, 35, 0.5) !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-webkit-slider-runnable-track {
  background-color: rgba(208, 159, 35, 0.5) !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-moz-range-track {
  background-color: rgba(208, 159, 35, 0.5) !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-ms-fill-lower {
  background-color: rgba(208, 159, 35, 0.45) !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-ms-fill-upper {
  background-color: rgba(208, 159, 35, 0.25) !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:active::-moz-range-thumb {
  box-shadow: 0 1px 3px 0 rgba(208, 159, 35, 0.25) !important;
  background-color: rgba(208, 159, 35, 0.25) !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:active::-ms-thumb {
  box-shadow: 0 1px 3px 0 rgba(208, 159, 35, 0.25) !important;
  background-color: rgba(208, 159, 35, 0.25) !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:active::-webkit-slider-thumb {
  -webkit-box-shadow: 0 1px 3px 0 rgba(208, 159, 35, 0.25) !important;
  box-shadow: 0 1px 3px 0 rgba(208, 159, 35, 0.25) !important;
  background-color: rgba(208, 159, 35, 0.25) !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-moz-range-thumb {
  box-shadow: 0 1px 3px 0 rgba(208, 159, 35, 0.75) !important;
  background-color: rgba(208, 159, 35, 0.75) !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-thumb {
  box-shadow: 0 1px 3px 0 rgba(208, 159, 35, 0.75) !important;
  background-color: rgba(208, 159, 35, 0.75) !important;
}

.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-webkit-slider-thumb {
  -webkit-box-shadow: 0 1px 3px 0 rgba(208, 159, 35, 0.75) !important;
  box-shadow: 0 1px 3px 0 rgba(208, 159, 35, 0.75) !important;
  background-color: rgba(208, 159, 35, 0.75) !important;
}
</style>



// WEBPACK FOOTER //
// ImageRender.vue?7e614310